import { appSwitchRoutes } from 'constants/routes';
import { ModalTypes } from 'enums/modalTypes';
import { Maybe, useStageCandidateFindOneQuery } from 'generated/graphql';
import { closeModal } from 'graphql/modals';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import EqualityAndDiversityFormContainer from './EqualityAndDiversityFormContainer/EqualityAndDiversityFormContainer';

interface IEquailityAndDiversityContainer {
  stageCandidateId: number;
  /** Company logo shown in the form header; hosts pass it from myRole data. */
  companyLogoUrl?: Maybe<string>;
  onEqualityStatementButtonClick: () => void;
}

const EquailityAndDiversityContainer: FC<IEquailityAndDiversityContainer> = ({
  stageCandidateId,
  companyLogoUrl,
  onEqualityStatementButtonClick,
}) => {
  const navigate = useNavigate();
  const { handleMsgType } = useNotification();

  const stageCandidateQueryResponse = useStageCandidateFindOneQuery({
    variables: {
      id: stageCandidateId,
    },
    onError: error => {
      handleMsgType({
        type: TNotification.error,
        message: error?.message,
      });

      closeModal(ModalTypes.CANDIDATE_INFORMATION);
      navigate(appSwitchRoutes.roles.getUrl());
    },
  });

  const stageCandidate =
    stageCandidateQueryResponse.data?.StageCandidateFindById;
  const companyId = stageCandidate?.companyId;
  const projectId = stageCandidate?.stage.projectId;

  if (companyId && projectId) {
    return (
      <EqualityAndDiversityFormContainer
        stageProjectCompanyId={companyId}
        projectId={projectId}
        stageProjectCompanyLogoUrl={companyLogoUrl}
        onEqualityStatementButtonClick={onEqualityStatementButtonClick}
      />
    );
  }

  return null;
};

export default EquailityAndDiversityContainer;
